import { render, staticRenderFns } from "./IndicationForm.vue?vue&type=template&id=b96b2548"
import script from "./IndicationForm.vue?vue&type=script&lang=js"
export * from "./IndicationForm.vue?vue&type=script&lang=js"
import style0 from "./IndicationForm.vue?vue&type=style&index=0&id=b96b2548&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports